import { completedStatusId } from '../constants/requests.constants';
import addRequestAttachment from './addRequestAttachment';
import getRequest from './getRequest';
import sendCommentToRequest from './sendCommentToRequest';
import updateRequestStatus from './updateRequestStatus';

const addFiles = (requestId, files) =>
  Promise.allSettled(
    files.map((file) => {
      const formData = new FormData();

      formData.append('file', file.originFileObj);

      return addRequestAttachment(
        requestId,
        file.originFileObj,
        `Не удалось загрузить вложение ${file.name}. Попробуйте сделать это из заявки`
      );
    })
  );

export const setStatusDoneAndGetRequest = async ({ requestId, data }) => {
  const { files, ...noteData } = data;
  const note = noteData.note.trim();

  await Promise.allSettled([
    note
      ? sendCommentToRequest(
          requestId,
          { note, availableForClient: noteData.availableForClient },
          'Не удалось добавить комментарий. Попробуйте сделать это из заявки'
        )
      : Promise.resolve(),

    files.length ? addFiles(requestId, files) : Promise.resolve(),

    updateRequestStatus(
      requestId,
      completedStatusId,
      'Не удалось установить статус "Выполнено"'
    ),
  ]);

  const updatedRequest = await getRequest(
    requestId,
    'Не удалось получить измененную заявку. Попробуйте обновить страницу'
  );

  return updatedRequest;
};
